var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentEntryUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_14196",
    "data-name": "Group 14196",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45.937,
    height: 81.066,
    viewBox: "0 0 45.937 81.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4228",
    "data-name": "Rectangle 4228",
    width: 45.937,
    height: 81.066,
    fill: "#56aa1c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11512",
    "data-name": "Group 11512",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36695",
    "data-name": "Path 36695",
    d: "M42.188,0H3.749A3.753,3.753,0,0,0,0,3.749V77.318a3.753,3.753,0,0,0,3.749,3.749H42.188a3.753,3.753,0,0,0,3.749-3.749V3.749A3.753,3.753,0,0,0,42.188,0M14.352,4.239a1.424,1.424,0,0,1,1.422-1.422H31.626a1.424,1.424,0,0,1,1.422,1.422v.109a1.424,1.424,0,0,1-1.422,1.422H15.775a1.424,1.424,0,0,1-1.422-1.422ZM23.7,76.651a3.346,3.346,0,1,1,3.346-3.345A3.35,3.35,0,0,1,23.7,76.651M43.5,66.463a1.966,1.966,0,0,1-1.964,1.964H5.863A1.966,1.966,0,0,1,3.9,66.463V9.936A1.966,1.966,0,0,1,5.863,7.972H41.538A1.966,1.966,0,0,1,43.5,9.936Z",
    transform: "translate(0 0)",
    fill: "#56aa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36696",
    "data-name": "Path 36696",
    d: "M34.717,41.754c-.262,1.572-1.136,2.185-3.19,3.19s-8.1.528-14.287-5.636C11.077,33.119,10.6,27.069,11.6,25.021s1.617-2.927,3.189-3.19c1.158-.193,1.724-.6,2.256-.067a3.15,3.15,0,0,1,.584.985,40.516,40.516,0,0,0,2.1,4.019s.874.962-.525,1.922a7.305,7.305,0,0,0-1.791,1.529c-.393.393-.616.621.174,2.272a13.5,13.5,0,0,0,2.376,3.52c.066.066.134.131.2.194l.176.176c.063.068.127.134.193.2a13.493,13.493,0,0,0,3.521,2.376c1.65.79,1.879.568,2.272.175a7.337,7.337,0,0,0,1.529-1.792c.961-1.4,1.923-.523,1.923-.523a40.344,40.344,0,0,0,4.019,2.1,3.162,3.162,0,0,1,.985.583c.532.532.126,1.1-.067,2.256",
    transform: "translate(0.58 1.743)",
    fill: "#56aa1c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentEntryUsers);
export default __webpack_public_path__ + "static/media/payment_entry_users.2f62d16e2d78165b562341d4be40d131.svg";
export { ForwardRef as ReactComponent };